"use client";

import React from 'react';
import Image from 'next/image';
// import { useRouter } from 'next/navigation';
import Link from 'next/link';

const MobileBottomNav: React.FC = () => {
  // const router = useRouter();

  // const handleSearchClick = () => {
  //   // Navigate to search page or trigger search functionality
  //   router.push('/product-category/products?search=');
  // };

  // const handleAllProductsClick = () => {
  //   router.push('/product-category/categories');
  // };

  return (
    <div className="fixed bottom-[0dvh] left-0 right-0 z-[100] lg:hidden">
      {/* Blue Navigation Bar */}
      <div className="bg-PrimaryLightBlue pl-[5.651vw] pr-[10.651vw] flex items-center justify-between">
        
        
        {/* Search Products Button */}
        {/* <button
          onClick={handleSearchClick}
          className="flex items-center gap-mob-8 py-mob-16 text-white uppercase font-medium text-mob-14 tracking-wider"
        > */}
        <Link 
          href={"/product-category/products?search="}
          className="flex items-center gap-mob-8 py-mob-16 text-white uppercase font-medium text-mob-14 tracking-wider"
        >
          <div className="relative w-mob-20 h-mob-20 shrink-0">
            <Image
              src="/images/searchIcon.svg"
              alt="Search"
              fill
              sizes="20px"
              className="object-contain filter"
            />
          </div>
          <span>SEARCH PRODUCTS</span>
        </Link>
        {/* </button> */}

        {/* Divider */}
        <div className="w-[1px] h-mob-24 bg-white opacity-50"></div>

        {/* All Products Button */}
        {/* <button
          onClick={handleAllProductsClick}
          className="flex items-center gap-mob-8 py-mob-16 text-white uppercase font-medium text-mob-14 tracking-wider"
        > */}
        <Link
          href={"/product-category/categories"}
          className="flex items-center gap-mob-8 py-mob-16 text-white uppercase font-medium text-mob-14 tracking-wider"
        >
          <div className="relative w-mob-20 h-mob-20 shrink-0">
            <Image
              src="/images/allProductIcon.svg"
              alt="All Products"
              fill
              sizes="20px"
              className="object-contain filter"
            />
          </div>
          <span>ALL PRODUCTS</span>
        </Link>
        {/* </button> */}
      </div>
    </div>
  );
};

export default MobileBottomNav; 